import { createTheme } from '@mui/material/styles';

// Thème global enrichi (fusion des deux fichiers)
export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#00b7e8',
      light: '#80e4ff',
      dark: '#004f74',
      contrastText: '#fff',
    },
    secondary: {
      main: '#d14b02',
      light: '#ff7b42',
      dark: '#a03600',
      contrastText: '#fff',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff'
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
    h1: {
      fontSize: '3rem',
      margin: '0.5rem',
      fontWeight: 600,
      color: '#00b7e8'
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 500,
      marginBottom: '1rem'
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 500,
      marginBottom: '1rem'
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      marginBottom: '0.75rem'
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      marginBottom: '0.5rem'
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '16px',
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '&:hover fieldset': {
              borderColor: '#00b7e8',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#00b7e8',
            }
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          padding: '10px 24px'
        },
        contained: {
          boxShadow: '0 2px 8px rgba(0, 183, 232, 0.3)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 183, 232, 0.4)',
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        }
      }
    }
  }
});

// Styles CSS globaux pour les conteneurs avec vos couleurs
export const globalStyles = `
  .app-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  .app-auth-container {
    max-width: 500px;
    margin: 40px auto;
    padding: 32px;
    background: white;
    border-radius: 12px;
    /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
    border: 4px solid #00b7e8;
  }

/*   .app-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  } */

  .app-form-error {
    color: #d14b02;
    font-size: 0.875rem;
    margin-top: 8px;
    background-color: #fff3e0;
    padding: 8px 12px;
    border-radius: 4px;
    border-left: 4px solid #d14b02;
  }

  .app-header {
    background: linear-gradient(135deg, #00b7e8 0%, #00a7d3 100%);
    color: white;
    padding: 24px;
    margin-bottom: 24px;
    border-radius: 12px;
  }

  .app-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 16px;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
    border-left: 4px solid #00b7e8;
  }
  
  .text-bold {
    font-weight: 700 !important;
  }

  /* Animation de focus pour l'accessibilité */
  .app-auth-container:focus-within {
    /* box-shadow: 0 4px 12px rgba(0, 183, 232, 0.3); */
    transform: translateY(-2px);
    transition: all 0.2s ease;
  }
`;

// Export des classes CSS pour usage programmatique
export const appClasses = {
  container: 'app-container',
  authContainer: 'app-auth-container',
  form: 'app-form',
  formError: 'app-form-error',
  header: 'app-header',
  card: 'app-card',
  textBold: 'text-bold'
};
